export enum HeaderDataHooks {
  DESCRIPTION = 'description',
}
